import { ProjectTechnicalModule } from '@gp/enums/project';

import ICON_ENGINE from '@gp/assets/svg/detail-project-technical/engine.svg';
import ICON_SERVER_PROVIDER from '@gp/assets/svg/detail-project-technical/server-provider.svg';
import ICON_PROGRAMMING_LANGUAGE from '@gp/assets/svg/detail-project-technical/programming-languate.svg';
import ICON_DATABASE from '@gp/assets/svg/detail-project-technical/database.svg';
import ICON_ANTI_CHEAT_SOLUTION from '@gp/assets/svg/detail-project-technical/anti-cheat-solution.svg';
import ICON_VERSION_CONTROL_SYSTEM from '@gp/assets/svg/detail-project-technical/version-control-system.svg';

interface IPipelineProjectTechnicalModuleCfg {
  icon: string;
  title: string;
}

export const TECHNICAL_MODULE_KEYS: ProjectTechnicalModule[] = [
  ProjectTechnicalModule.Engine,
  ProjectTechnicalModule.ServerProvider,
  ProjectTechnicalModule.ProgrammingLanguage,
  ProjectTechnicalModule.DatabaseAndDataService,
  ProjectTechnicalModule.AntiCheatSolution,
  ProjectTechnicalModule.VersionControlSystem,
];

export const TECHNICAL_MODULE_NAME_MAPPING: Record<ProjectTechnicalModule, string> = {
  [ProjectTechnicalModule.Engine]: 'Engine',
  [ProjectTechnicalModule.ServerProvider]: 'Server Provider',
  [ProjectTechnicalModule.ProgrammingLanguage]: 'Programming Language',
  [ProjectTechnicalModule.DatabaseAndDataService]: 'Database & Data Service',
  [ProjectTechnicalModule.AntiCheatSolution]: 'Anti-Cheat Solution',
  [ProjectTechnicalModule.VersionControlSystem]: 'Version Control System',
};

export const PIPELINE_PROJECT_TECHNICAL_MODULE_CFG_MAPPINGS: Record<
ProjectTechnicalModule,
IPipelineProjectTechnicalModuleCfg
> = {
  [ProjectTechnicalModule.Engine]: {
    icon: ICON_ENGINE,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.Engine],
  },
  [ProjectTechnicalModule.ServerProvider]: {
    icon: ICON_SERVER_PROVIDER,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.ServerProvider],
  },
  [ProjectTechnicalModule.ProgrammingLanguage]: {
    icon: ICON_PROGRAMMING_LANGUAGE,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.ProgrammingLanguage],
  },
  [ProjectTechnicalModule.DatabaseAndDataService]: {
    icon: ICON_DATABASE,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.DatabaseAndDataService],
  },
  [ProjectTechnicalModule.AntiCheatSolution]: {
    icon: ICON_ANTI_CHEAT_SOLUTION,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.AntiCheatSolution],
  },
  [ProjectTechnicalModule.VersionControlSystem]: {
    icon: ICON_VERSION_CONTROL_SYSTEM,
    title: TECHNICAL_MODULE_NAME_MAPPING[ProjectTechnicalModule.VersionControlSystem],
  },
};
